module.exports = __webpack_public_path__ + "static/media/background.c6016b27.png";